import { render, staticRenderFns } from "./UpdateShablonStatus.vue?vue&type=template&id=5d8a8016"
import script from "./UpdateShablonStatus.vue?vue&type=script&lang=js"
export * from "./UpdateShablonStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateShablonStatus.vue?vue&type=style&index=0&id=5d8a8016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports